import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectWidgetEffectiveCols } from '../redux/datasourceSlice.js';
import { useFormulaFields } from './useFormulaFields.js';

/**
 * Select options for chart column pickers: the widget's effective (filtered/pivoted) columns,
 * followed by the widget's formula fields.
 *
 * @param {number} widgetId
 * @returns {Array<{label: string, value: string}>}
 */
export const useChartColumnOptions = (widgetId) => {
  const cols = useSelector(selectWidgetEffectiveCols(widgetId));
  const { formulaFields } = useFormulaFields(widgetId);

  return useMemo(() => [
    ...cols.map(col => ({ label: col.name, value: col.accessor })),
    ...formulaFields.map(f => ({ label: `ƒ ${f.name}`, value: f.accessor })),
  ], [cols, formulaFields]);
};
